import { render, staticRenderFns } from "./Func0Noticias.vue?vue&type=template&id=d2c2422e"
import script from "./Func0Noticias.vue?vue&type=script&lang=js"
export * from "./Func0Noticias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports